import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { regexValidators } from '../../../validator';

@Component({
  selector: 'app-username-field',
  templateUrl: './username-field.component.html'
})
export class UsernameFieldComponent implements OnInit {
  maskSettings;
  usernameMaskSettings = {
    mask: regexValidators.phone,
    guide: true,
    showMask: false
  };
  usernameModel = null;
  firstBlurInput = false;
  isDisabledField = false;

  @Output() changeValue = new EventEmitter<string>();
  @Output() keyUpField = new EventEmitter<any>();
  @Input() placeholder;
  @Input() classList;
  @Input('disabled') set disabled(disabled) {
    this.isDisabledField = disabled;
  }
  @Input() initialValue;


  ngOnInit() {
    this.maskSettings = this.usernameMaskSettings;
    if (this.initialValue) {
      if (this.initialValue.charAt(0) === '+') {
        this.initialValue = this.initialValue.slice(1);
      }


      if (this.initialValue.charAt(0) === '7') {
        this.initialValue = this.initialValue.slice(1);
      } else {
        this.initialValue = '+' + this.initialValue;
        this.maskSettings = { mask: false };
      }

      this.usernameModel = this.initialValue;
    }

  }

  onKeyUpMask() {
    // this.errorMessage = '';
    if (!this.usernameModel || !this.usernameModel.length) {
      this.maskSettings = { mask: false };
      setTimeout(() => {
        this.usernameModel = '+';
      });
    } else if (this.usernameModel === '+7') {
      this.maskSettings = this.usernameMaskSettings;
    }
    this.changeValue.emit(this.usernameModel);
  }

  onBlurMask() {
    if (this.maskSettings && this.maskSettings.mask) {
      if (this.usernameModel && (this.usernameModel.indexOf('_') >= 0 || this.usernameModel.length <= 2)) {
        setTimeout(() => {
          this.usernameModel = null;
        });
      }
    }
    this.changeValue.emit(this.usernameModel);
  }

  onFocusMask() {
    let timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (this.maskSettings && this.maskSettings.mask && (this.usernameModel === '' || this.usernameModel === null)) {
        if (!this.firstBlurInput && this.ifAutofill()) {
          this.firstBlurInput = true;
        } else {
          this.usernameModel = ' ';
        }
      }
    });
  }

  ifAutofill() {
    const style = window.getComputedStyle(document.getElementsByClassName('username-field-js')[0]);
    if (style.getPropertyValue('column-fill') === 'auto') {
      return true;
    } else {
      return false;
    }
  }

  onKeyUpField(event: any) {
    this.keyUpField.emit(event);
    this.changeValue.emit(this.usernameModel);
  }
}




// WEBPACK FOOTER //
// ./src/app/view/components/username-field/username-field.component.ts